import React from 'react'
import { Skeleton, Typography } from '../../../../../components/common' 
import { CommentLists } from './Comments'
import { TicketBasicDetails } from './TicketBasicDetails'
import { useQuery } from '@apollo/client'
import { GET_FRESHDESK_TICKET_DETAILS } from '../../../../../grapghQl/queries/freshDesk'
import propTypes from "prop-types"

const commonProps = {
    title: propTypes.string,
    handleCloseDrawer: propTypes.func,
    children: propTypes.element,
    subject: propTypes.string,
    id: propTypes.string,
}

const TicketDetailsTitle = ({ handleCloseDrawer = () => null, title = "" }) => {
    return (
        <div className='flex justify-between w-full items-center'>
            <Typography variant="xl" className="font-semibold" text={title} />
             
        </div>
    )
}

TicketDetailsTitle.propTypes = commonProps;

const SingleItem = ({ children = <></>, title = "" }) => {
    return (<div className='flex flex-col gap-2.5'>
        <Typography className="text-secondary-400 font-normal text-[14px]" text={title} />
        {children}
    </div>
    )
}

SingleItem.propTypes = commonProps;

const TicketDescription = (props) => {
    const { viewGreyTHRTicket = {}, loading = false } = props || { viewGreyTHRTicket: {}, loading: false }
    const { description_text = '' } = viewGreyTHRTicket || { description_text: "" }

    return (<div className='w-full border-b py-4 border-secondary-200'>
        <SingleItem title="Description" >
            <div className='flex items-center gap-1'>
                {loading ?
                    <Skeleton length={4} className="h-3 w-full rounded-sm gap-1 my-1" /> :
                    <Typography variant="base" className="text-secondary-500 font-normal" text={description_text} />}
            </div>
        </SingleItem>
    </div>)
}

export const SupportTicketDetails = (props) => {
    const { id = null, subject = "", handleCloseDrawer = () => null } = props
    const title = `#${id} ${subject}`

    const { data, loading } = useQuery(GET_FRESHDESK_TICKET_DETAILS, {
        fetchPolicy: 'no-cache',
        variables: { ticketId: id },
        skip: !id
    })
    const { viewGreyTHRTicket = {} } = data || { viewGreyTHRTicket: {} }

    return (
        <div className='py-3'>
            <TicketDetailsTitle title={title} handleCloseDrawer={handleCloseDrawer} />
            <div className='my-2 mx-4'>
                <TicketBasicDetails {...props} viewGreyTHRTicket={viewGreyTHRTicket} loading={loading} />
                <TicketDescription {...props} viewGreyTHRTicket={viewGreyTHRTicket} loading={loading} />
                <CommentLists  {...props} viewGreyTHRTicket={viewGreyTHRTicket} loading={loading} />
            </div>
        </div>
    )
}

SupportTicketDetails.propTypes = commonProps;